import React, { useState } from "react";
import { ChevronUp, PhoneCall, ChevronDown, Globe, MapPin } from "lucide-react";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState(0);

  const handleToggle = (index) =>
    setOpenIndex(openIndex === index ? null : index);

  const faqs = [
    {
      q: "What is WhatsApp Automation?",
      a: "WhatsApp Automation involves using software to automate messaging and communication on WhatsApp. It helps streamline business processes such as Customer Support, Promotional Messages, and Reminders by automating repetitive tasks. Implementing WhatsApp Automation can save Time and Resources, Improve Response Times, and Enhance Customer Satisfaction.",
    },
    {
      q: "What is Bulk Messaging on WhatsApp?",
      a: "WhatsApp Bulk Messaging allows you to send a large number of messages to multiple recipients simultaneously. Our platform Isancharr facilitates this process by integrating with WhatsApp API, enabling you to Compose your Message, Select your Recipients, and Schedule or Send the message instantly. It's an efficient way to reach a wide audience quickly and effectively.",
    },
    {
      q: "Is WhatsApp Bulk Messaging legal and compliant with WhatsApp terms of service?",
      a: "Yes, our platform ensures compliance with WhatsApp terms of service and legal regulations regarding bulk messaging. We strictly adhere to WhatsApp guidelines, ensuring that messages are sent only to opted-in recipients who have consented to receive communications from your business.",
    },
    {
      q: "Can I Automate Messages on WhatsApp?",
      a: "Yes, you can easily Automate WhatsApp Messages using the WhatsApp Business App or WhatsApp Business API. The WhatsApp Business App allows Automation of Welcome and Away Messages, while the API enables automation of common customer queries.",
    },
  ];

  return (
    <div className="w-full bg-white font-inter px-4 sm:px-6 md:px-8 lg:px-12 xl:px-20 my-8 lg:my-20">
      <div className="w-full max-w-[1200px] mx-auto flex flex-col lg:flex-row gap-8">
        {/* LEFT FAQ SECTION */}
        <div className="w-full lg:w-1/2 border border-gray-300 rounded-[10px] p-4 md:p-6">
          <div className="text-center text-2xl md:text-3xl font-medium py-6 text-heading-blue">
            FAQs
          </div>

          <div className="space-y-2">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className={`rounded-[10px] transition-colors duration-300 ${
                  openIndex === index
                    ? "bg-text-secondary/10 border-text-secondary"
                    : "border-b border-text-secondary/10"
                }`}
              >
                <div
                  className="flex justify-between items-center p-4 cursor-pointer select-none"
                  onClick={() => handleToggle(index)}
                >
                  <div className="text-base sm:text-lg font-medium pr-4">
                    {faq.q}
                  </div>

                  <div className="shrink-0">
                    {openIndex === index ? <ChevronUp /> : <ChevronDown />}
                  </div>
                </div>

                <div
                  className={`overflow-hidden transition-all duration-300 ease-in-out ${
                    openIndex === index
                      ? "max-h-96 opacity-100"
                      : "max-h-0 opacity-0"
                  }`}
                >
                  <div className="px-4 pb-4">
                    <hr className="border-gray-400 mb-3" />
                    <p className="text-gray-600 leading-relaxed text-sm sm:text-base">
                      {faq.a}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* RIGHT CONTACT SECTION */}
        <div className="w-full lg:w-1/2 rounded-[10px] bg-brand-primary p-5 sm:p-6 md:p-8 flex flex-col justify-between text-white shadow-xl">
          <div className="mb-8">
            <div className="text-center text-2xl md:text-3xl font-bold py-4">
              Contact Us
            </div>

            <p className="text-center opacity-90 px-2 text-sm sm:text-base leading-relaxed">
              Unleash Quality Leads, Nurture, and Interact through WhatsApp
              after Clicks!
            </p>
          </div>

          <div className="flex flex-col gap-6">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 xl:grid-cols-2 gap-4">
              {/* SUPPORT CARD */}
              <div className="bg-white rounded-[14px] p-5 flex flex-col items-center shadow-sm min-w-0">
                <div className="p-3 mb-2">
                  <Globe size={40} className="text-heading-blue" />
                </div>

                <div className="text-base sm:text-lg font-semibold text-brand-primary text-center">
                  Chat to Support
                </div>

                <a
                  href="https://mail.google.com/mail/?view=cm&fs=1&to=support@isancharr.com"
                  className="text-gray-800 text-sm sm:text-[15px] mt-1 font-medium break-all text-center hover:underline"
                >
                  support@isancharr.com
                </a>
              </div>

              {/* CALL CARD */}
              <div className="bg-white rounded-[14px] p-5 flex flex-col items-center shadow-sm min-w-0">
                <div className="p-3 mb-2">
                  <PhoneCall size={40} className="text-heading-blue" />
                </div>

                <div className="text-base sm:text-lg font-semibold text-brand-primary text-center">
                  Call Us
                </div>

                <p className="text-gray-800 font-medium mt-1 text-sm sm:text-base text-center">
                  +91-9958853167
                </p>
              </div>
            </div>

            {/* ADDRESS CARD */}
            <div className="bg-white rounded-[14px] p-5 sm:p-6 flex flex-col items-center shadow-sm">
              <div className="p-3 mb-2">
                <MapPin size={40} className="text-heading-blue" />
              </div>

              <div className="text-base sm:text-lg font-semibold text-brand-primary">
                Visit Us
              </div>

              <p className="text-gray-800 font-medium text-center mt-2 px-0 sm:px-4 leading-snug text-sm sm:text-base">
                Ithum Tower, Tower-B, 218, Second Floor, Sector 62,
                Noida-201309
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}